module.exports = __webpack_public_path__ + "static/media/lineBasedh.c0fc2b66.svg";